import React from 'react'

import {
  SectionGroup,
  SectionItem,
  SectionItemGrupoParcela,
  SectionItemParcela,
  SectionItemValue,
  type SectionItemProps,
} from '@/components/ui'
import type { SectionItemGrupoParcelaProps, SectionItemParcelaProps } from '@/components/ui/section/section-parcela'
import { formatToBRL } from '@/utils/currency.utils'

interface TItemValue extends SectionItemProps {
  value: number
}
export const createValueItem = (
  label: string,
  value: number,
  colSpan?: 4 | 6 | 8 | 12,
  withRightBorder = false,
): FactoryItem => ({
  type: 'value',
  data: { label, value, colSpan, withRightBorder },
})

export const createParcelaItem = (
  label: string,
  parcela: { data: string; valor: number } | null,
  colSpan?: 4 | 8 | 12,
  withRightBorder = false,
): FactoryItem => ({
  type: 'parcela',
  data: { label, parcela: parcela ?? undefined, colSpan, withRightBorder },
})

export const createGrupoParcelaItem = (
  label: string,
  parcelas: Array<{ valor: number; quantidade: number }> | undefined,
  colSpan?: 4 | 8 | 12,
  withRightBorder = false,
): FactoryItem => ({
  type: 'grupoParcela',
  data: { label, parcelas, colSpan, withRightBorder },
})

type FactoryItem =
  | { type: 'value'; data: TItemValue }
  | { type: 'parcela'; data: SectionItemParcelaProps<{ data: string; valor: number }> }
  | { type: 'grupoParcela'; data: SectionItemGrupoParcelaProps<Array<{ valor: number; quantidade: number }>> }
const renderFactoryItem = (item: FactoryItem) => {
  switch (item.type) {
    case 'value':
      return (
        <SectionItem label={item.data.label} colSpan={item.data.colSpan} withRightBorder={item.data.withRightBorder}>
          <SectionItemValue>{formatToBRL(item.data.value)}</SectionItemValue>
        </SectionItem>
      )
    case 'parcela':
      return <SectionItemParcela {...item.data} />
    case 'grupoParcela':
      return <SectionItemGrupoParcela {...item.data} />
  }
}

export interface SectionGroupFactoryItem {
  withBorder?: boolean
  items: FactoryItem[]
}
const SectionGroupFactory = ({ withBorder = false, items }: SectionGroupFactoryItem) => (
  <SectionGroup withBorder={withBorder}>
    {items.map((item) => (
      <React.Fragment key={`${item.type}-${item.data.label}`}>{renderFactoryItem(item)}</React.Fragment>
    ))}
  </SectionGroup>
)

export const ValoresSimuladosFactory = ({ grupos }: { grupos: SectionGroupFactoryItem[] }) => (
  <React.Fragment>
    {grupos.map((grupo) => (
      <SectionGroupFactory key={`grupo-${grupo.items[0]?.data.label}`} {...grupo} />
    ))}
  </React.Fragment>
)
